module.exports = __webpack_public_path__ + "static/media/meter1.6f02d292.svg";